import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=394ce8d2&scoped=true"
import script from "./Employment.vue?vue&type=script&lang=js"
export * from "./Employment.vue?vue&type=script&lang=js"
import style0 from "./Employment.vue?vue&type=style&index=0&id=394ce8d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ce8d2",
  null
  
)

/* custom blocks */
import block0 from "./Employment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports